import { Button } from "@fluentui/react-components";
import { memo } from "react";
import { useSuggestionMoreLoaderStyles } from "../styles/SuggestionMoreLoader.styles";

export const SuggestionMoreLoader = memo(({ context: { loadMore, loading } }: any) => {
  // TODO: NEEDS TO RETURN THE SEARCH CLAUSES TOTAL COUNT TO CHECK IF WE CAN LOAD MORE OR NOT
  //   const [moreAvailable] = useAppData<boolean>(appId, "moreAvailable");

  //   if (!moreAvailable) {
  //     return <></>;
  //   }
  const styles = useSuggestionMoreLoaderStyles();

  return (
    <div className={styles.container}>
      {!loading && (
        <Button appearance="primary" onClick={loadMore} className={styles.button}>
          Expand Search
        </Button>
      )}
    </div>
  );
});
